import React from 'react';
import { Box } from '@common-fe/common-fe';

import { ContributionSource, RecordsInfo } from '@/modules/employer/components/Contributions/contributions.types';

import { ContributionInvoiceListItem } from './ContributionInvoiceListItem';

interface Props {
  data?: RecordsInfo[];
  payrollCalendarName?: string;
  contributionSource?: string;
}

export const ContributionInvoiceList: React.FC<Props> = ({ data, payrollCalendarName, contributionSource }) => (
  <Box
    background={{ color: 'module' }}
    round="container1Round"
    pad="spacing16"
    margin={{ top: 'spacing16' }}
    gap="spacing8"
    data-testid="ContributionInvoiceList_container"
  >
    {
      data?.map((item) => (
        <ContributionInvoiceListItem 
          key={item.planCode} 
          record={item} 
          payrollCalendarName={contributionSource === ContributionSource.SCHEDULED ? payrollCalendarName : undefined}
        />
      ))
    }
  </Box>
);
